import axios from 'axios';
import { transcribeAction } from './TranscribeSlice';

const getTranscribeData = (wavFile, token, signal) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/transcribe`;
      const formData = new FormData();
      formData.append("file", wavFile, "voice_recording.wav");
      const headers = { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" };
      const response = await axios.post(url, formData, { headers, signal });
      return response;
    };
    try {
      const result = await fetchData();
      const transcribeData = result.data;
      dispatch(transcribeAction.transcribeHandler({ transcribeData }));
    } catch (e) {
      const errorData = e?.response?.data || { error: e.message || "unknown_error" };
      dispatch(transcribeAction.transcribeHandler({ error: errorData }));
    }
  };
};

export default getTranscribeData;